import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
//import { ExportToCsv } from 'export-to-csv';
import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { LeadDetails } from '../../types/leads';
import { EcmsEntry } from '../../types/ecms-entry';
import { EcmsStatus } from '../../types/ecms-status';
import { ExportToCsv } from 'export-to-csv';
import { DatePipe } from '@angular/common';


/**
 * @title Table with sticky columns
 */

export interface Report {
    DateCompleted: string;
    Period: string;
    Measure: string;
    MPRN: string;
    CustomerRef: string;
    DwellingType: string;
    ProjectID: string;
    PublicSector: string;
    Contractor: string;
    EnergyCredits: string;
    ProjectName: string;
    Phone: string;
    Eircode: string;
    Address: string;
}

@Component({
    selector: 'ecms-table',
    styleUrls: ['ecms-table.component.css'],
    templateUrl: 'ecms-table.component.html',
    providers: [HubService, DatePipe],
})
export class ECMSTableComponent implements OnInit {
    errorMessage: string;
    type: string;

    ecmsList = <EcmsEntry[]>[];
    ecmsStatusList = <EcmsStatus[]>[];
    totalMPRNList: number[];
    loading_data: boolean;
    refresh_allowed: boolean;
    checkAll: boolean = false;

    checkbox: number[] = [];

    @Output() rowCountEvent = new EventEmitter<string>();
    @Output() mprnList = new EventEmitter<number[]>();
    searchParams = {} as EcmsEntry;

    start_offset: number;
    end_offset: number;
    STEP = 200;
    INIT_SIZE = 500;
    LAST_POSITION = 0;

    constructor(
        private hubService: HubService,
        private datePipe: DatePipe
    ) { }

    ngOnInit(): void {
        console.log("ngOnInit()");
        if (!AppComponent.IsLoggedIn()) { return; }

        this.start_offset = 0;
        this.loading_data = true;
        this.refresh_allowed = true;
        this.type = "all";

        var temp = {} as EcmsEntry;
        this.ecmsList.push(temp);

        this.hubService.getLookupTable('ecms_status').subscribe(
            lookup_values => this.ecmsStatusList = <EcmsStatus[]>lookup_values,
            error => this.errorMessage = <any>error,
        );

        this.initalize(this.searchParams, this.type);
    }

    @ViewChild(CdkVirtualScrollViewport)
    public viewPort: CdkVirtualScrollViewport;


    public get inverseOfTranslation(): string {
        if (!this.viewPort || !this.viewPort["_renderedContentOffset"]) {
            return "-0px";
        }
        let offset = this.viewPort["_renderedContentOffset"];
        return `-${offset}px`;
    }

    initalize(search: EcmsEntry, type: string): void {
        this.start_offset = 0;
        this.checkbox = [];
        this.mprnList.emit(this.checkbox);
        this.type = type;

        if (this.searchParams.ecms_id) {
            this.searchParams.ecms_id = +this.searchParams.ecms_id;
        }

        if (this.searchParams.ecms_status_id) {
            this.searchParams.ecms_status_id = +this.searchParams.ecms_status_id;
        }

        if (this.searchParams.hub_batch) {
            this.searchParams.hub_batch = +this.searchParams.hub_batch;
        }

        if (this.searchParams.ei_batch) {
            this.searchParams.ei_batch = +this.searchParams.ei_batch;
        }

        if (this.searchParams.serial_no) {
            this.searchParams.serial_no = +this.searchParams.serial_no;
        }

        if (this.searchParams.end_time) {
            this.searchParams.end_time = new Date(this.searchParams.end_time);
        }

        if (this.searchParams.date_sent) {
            this.searchParams.date_sent = new Date(this.searchParams.date_sent);
        }

        if (this.searchParams.last_seen) {
            this.searchParams.last_seen = new Date(this.searchParams.last_seen);
        }

        if (this.searchParams.ecms_status_text) {
            for (var i = 0; i < this.ecmsStatusList.length; ++i) {
                if (this.searchParams.ecms_status_text.toLocaleLowerCase() == this.ecmsStatusList[i].ecms_status_text.toLocaleLowerCase()) {
                    this.searchParams.ecms_status_id = this.ecmsStatusList[i].ecms_status_id;
                }
            }
        }

        try {
            this.loading_data = true;
            console.log("loading_data: ", this.loading_data);
            this.hubService.postEcms(this.type, this.start_offset, this.INIT_SIZE, search).subscribe(
                ecmsEntry => {
                    this.ecmsList = ecmsEntry;
                    this.end_offset = this.INIT_SIZE;
                    if (LeadDetails.length == 0) {
                        var temp = {} as EcmsEntry;
                        this.ecmsList.push(temp);
                    }
                    this.loading_data = false;
                },
                error => this.errorMessage = <any>error,
            );

            this.hubService.postEcmsMPRN(this.type, search).subscribe(
                mprnTotal => {
                    this.totalMPRNList = [];
                    for(var i = 0; i < mprnTotal.list.length; i++){
                        this.totalMPRNList.push(+mprnTotal.list[i]['mprn'])
                    }
                },
                error => this.errorMessage = <any>error,
            );

            this.hubService.postEcmsCount(this.type, this.start_offset, this.INIT_SIZE, search, true).subscribe(
                EcmsCount => this.rowCountEvent.emit(EcmsCount.list[0]['count']),
                error => this.errorMessage = <any>error,
            );
        } catch (e) {
            console.log("error............")
            console.log('Meh: ' + e);
        }
    }

    refresh(step: any, down: boolean, event: any, search: EcmsEntry): void {
        try {
            //    this.loading = true;
            console.log("refresh loading.........");
            var temp_offset;
            //Scrolling Down
            if (down) {
                temp_offset = this.end_offset;
            }
            //Scrolling Up
            if (!down) {
                temp_offset = this.start_offset;
            }

            event['srcElement']['scrollTop'] = event['srcElement']['scrollHeight'] / 2;

            this.hubService.postEcms(this.type, temp_offset, step, search).subscribe(
                ecmsEntrys => {
                    console.log("Pre Update length: " + this.ecmsList.length);
                    if (down) {
                        var removed = this.ecmsList.splice(0, this.STEP);
                        this.ecmsList = this.ecmsList.concat(...ecmsEntrys);
                        this.end_offset += this.STEP;
                        this.start_offset = this.end_offset - this.INIT_SIZE - this.STEP;
                        console.log("Removed Down: " + removed.length + " Start: ", this.start_offset + " End: ", this.end_offset);
                    }

                    if (!down) {
                        var removed = this.ecmsList.splice((this.end_offset - this.INIT_SIZE), this.STEP);
                        this.ecmsList = ecmsEntrys.concat(this.ecmsList);
                        if (this.end_offset > this.INIT_SIZE) {
                            this.end_offset -= this.STEP;
                        }
                        if (this.start_offset != 0) {
                            this.start_offset = this.start_offset - this.STEP;
                        }
                        console.log("Removed Up: " + removed.length + " Start: ", this.start_offset + " End: ", this.end_offset);
                    }

                    console.log("Post Update length: " + this.ecmsList.length);
                    console.log("refresh loaded.........");
                    this.refresh_allowed = true;
                },
                error => this.errorMessage = <any>error,
            );
        } catch (e) {
            console.log("error............");
            console.log('Meh: ' + e);
        }
    }

    getColor(c: any, end_time: string, last_seen: string): string {
        if(this.type != 'raw' && this.type != 'nogeopal' && this.type != 'offline' && !this.loading_data){
            if (end_time == null || last_seen == null) {
                return '#FF0000'
            }
    
            var last_seen_date = new Date(last_seen)
            var end_time_date = new Date(end_time)
    
            if (last_seen_date < end_time_date) {
                return '#FF0000'
            }
        }
      
        if (c % 2 == 0) {
            return "#dadada";
        } else {
            return "white"
        }
    }
 
    scrolled(event: any): void {
        //console.log("--------------------------------");
        //console.log("ScrollTop" + event['srcElement']['scrollTop']);
        //console.log("ScrollHeight" + event['srcElement']['scrollHeight']);
        //console.log("--------------------------------");

        //Scroll Down
        if (this.LAST_POSITION < event['srcElement']['scrollTop']) {
            console.log("Scroll Down page");
            if (event['srcElement']['scrollTop'] > ((event['srcElement']['scrollHeight'] / 4) * 3)) {//3 *2
                if (this.refresh_allowed) {
                    this.refresh_allowed = false;
                    this.refresh(this.STEP, true, event, this.searchParams);
                } else {
                    console.log("NO REFRESH!!!");
                }
            }
        }
        //Scroll Up
        if (this.LAST_POSITION > event['srcElement']['scrollTop']) {
            console.log("Scroll Up page");
            if (event['srcElement']['scrollTop'] < ((event['srcElement']['scrollHeight'] / 4) * 1)) { // 6*1
                if (this.end_offset != this.INIT_SIZE) {
                    if (this.refresh_allowed) {
                        this.refresh_allowed = false;
                        this.refresh(this.STEP, false, event, this.searchParams);
                    } else {
                        console.log("NO REFRESH!!!");
                    }

                }

            }
        }
        this.LAST_POSITION = event['srcElement']['scrollTop'];
    }

    search() {
        console.log(this.searchParams);
        this.initalize(this.searchParams, this.type);
    }

    cancel(id: string) {
        switch (id) {
            case 'ecms_id':
                this.searchParams.ecms_id = null;
                break;
            case 'job_id':
                this.searchParams.job_id = null;
            case 'first_name':
                this.searchParams.first_name = null;
                break;
            case 'address_line_1':
                this.searchParams.address_line_1 = null;
                break;
            case 'contact_mobile':
                this.searchParams.contact_mobile = null;
                break;
            case 'ecms_status_text':
                this.searchParams.ecms_status_text = this.searchParams.ecms_status_id = null;
            case 'end_time':
                this.searchParams.end_time = null;
                break;
            case 'mprn':
                this.searchParams.mprn = null;
                break;
            case 'serial_no':
                this.searchParams.serial_no = null;
                break;
            case 'post_code':
                this.searchParams.post_code = null;
            case 'last_seen':
                this.searchParams.last_seen = null;
                break;
            case 'date_sent':
                this.searchParams.date_sent = null;
                break;
            case 'hub_batch':
                this.searchParams.hub_batch = null;
                break;
            case 'ei_batch':
                this.searchParams.ei_batch = null;
            case 'comment':
                this.searchParams.comment = null;
                break;
            case 'company_name':
                this.searchParams.company_name = null;
                break;
        }

        this.initalize(this.searchParams, this.type);
    }

    updateLeads(uid: number, update: any, event: any) {
        var leadsDetails = <LeadDetails[]>[];
        var tempLead = new LeadDetails;

        console.log(event);
        tempLead.uid = uid;
        switch (event) {
            case "next_duplicate": {
                //tempLead.duplicate = update;
                break;
            }
            case "next_installer_company_name": {
                //tempLead.installer_name = update;
                break;
            }
        }
        /*
        leadsDetails.push(tempLead);
        console.log(leadsDetails);
        this.hubService.writeLeadsDetails(leadsDetails)
            .subscribe(
                data => console.log(data.status),
                error => this.errorMessage = <any>error,
            );*/
    }

    exportEcmsCSV(): void {
        var report = <Report[]>[];
        let tempDate = new Date().toLocaleString();
        try{
            this.hubService.postEcmsCsv(this.checkbox).subscribe(
                ecmsCsv => {
                    console.log(ecmsCsv);
                    ecmsCsv.forEach( entry => {
                        var temp = {} as Report;
                        temp.Period = " "
                        temp.Measure = " ";
                        temp.MPRN = entry.mprn;
                        temp.CustomerRef = " ";
                        temp.DwellingType = " ";
                        temp.ProjectID = " ";
                        temp.PublicSector = " ";
                        temp.Contractor = this.getCompanyName(entry.company_name);   
                        temp.EnergyCredits = " ";
                        temp.ProjectName = " ";
                        temp.Address = this.getAddress(entry.address_line_1, entry.address_line_2);
                        temp.Phone = entry.contact_mobile;
                        temp.Eircode = entry.post_code;
                        temp.DateCompleted = this.datePipe.transform(entry.end_time,'dd/MM/yyyy');
                        report.push(temp);
                    });

                    const options = {
                        filename: `Ecms Report${tempDate}`,
                        useKeysAsHeaders: true,
                    };
                    const csvExporter = new ExportToCsv(options);
                   csvExporter.generateCsv(report);
                },
                error => this.errorMessage = <any>error,
            );
        }catch(e){
            console.log('Meh: ' + e);
        }
    }

    addId(id: any): void {
        var index = this.checkbox.findIndex(e => e == id)
        if (index == -1) {
            this.checkbox.push(+id);
        } else {
            this.checkAll = false;
            this.checkbox.splice(index, 1);
        }
        this.mprnList.emit(this.checkbox);
    }

    checkForVal(id: any): boolean {
        if (this.checkAll) {
            return true
        }
        var index = this.checkbox.findIndex(e => e == id)
        if (index == -1) {
            return false;
        } else {
            return true;
        }
    }

    masterBox(): void {
        if (!this.checkAll) {
            this.checkbox = [];
            this.mprnList.emit(this.checkbox);
        }else{
            this.checkbox = [];
            this.checkbox = this.totalMPRNList.slice(0);
            this.mprnList.emit(this.checkbox);
        }
    }

    initalizeFromParent(search: EcmsEntry, type: string):void{
        this.checkAll = false;
        this.masterBox();
        this.initalize(search, type);
    }

    getCompanyName(company: string): string {
        if(company != undefined){
            if (company.toLowerCase() == "hub001") {
                return "Insight"
            } else if (company.toLowerCase() == "hes0005") {
                return "HES"
            }else if (company.toLowerCase() == "hub") {
                return "EnergyServe "
            }
        }
        return "Unknown"
    }

    getAddress(address1: string, address2: string): string {
        if (address1 != undefined && address2 != undefined) {
            return address1.length > address2.length ? address1 : address2
        } else if (address2 != undefined) {
            return address2
        } else if (address1 != undefined) {
            return address1
        } else {
            return "Unavailble ATM"
        }
    }
}
